import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex min-h-[48px] w-full rounded-md border border-rule bg-surface px-[15px] py-3 text-base text-ink transition-[background-color,border-color] duration-state file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-ink-55/70 focus-visible:outline-none focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
